import type { ListingItem } from "@/hooks/use-paginated-feed";
import type { CategorySortMode } from "@/components/feed/mockDiscoverData";

export function sortLiveDiscoverListings(items: ListingItem[], mode: CategorySortMode): ListingItem[] {
  const copy = [...items];
  if (mode === "recommended") {
    return copy;
  }
  if (mode === "newest") {
    copy.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    return copy;
  }
  if (mode === "price-asc") {
    copy.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    return copy;
  }
  if (mode === "price-desc") {
    copy.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
    return copy;
  }
  const auctions = copy.filter((l) => l.listing_format === "auction" && l.auction_end_at);
  const rest = copy.filter((l) => !(l.listing_format === "auction" && l.auction_end_at));
  auctions.sort(
    (a, b) => new Date(a.auction_end_at!).getTime() - new Date(b.auction_end_at!).getTime()
  );
  return [...auctions, ...rest];
}

export function liveCategoryHasAuctions(items: ListingItem[]): boolean {
  return items.some((l) => l.listing_format === "auction" && l.auction_end_at);
}
